import { Link } from 'react-router-dom';

const features = [
  {
    icon: 'ri-shield-check-line',
    title: '高清不缓冲',
    desc: '全站4K超清画质，智能CDN加速，播放流畅不卡顿，带来极致观影体验。',
  },
  {
    icon: 'ri-flashlight-line',
    title: '即点即播',
    desc: '免注册免登录，点击即可播放。无需下载任何插件，打开浏览器就能看。',
  },
  {
    icon: 'ri-stack-line',
    title: '海量资源',
    desc: '收录10万+影视资源，涵盖电影、电视剧、综艺、动漫、纪录片等全品类内容。',
  },
  {
    icon: 'ri-smartphone-line',
    title: '多端同步',
    desc: '支持电脑、平板、手机等多终端观看，随时随地享受高清影视的乐趣。',
  },
];

export default function FeaturesBar() {
  return (
    <section className="w-full px-4 md:px-6 py-12 md:py-16 bg-background-100">
      <div className="max-w-[1400px] mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950">
            为什么选择午马影院？
          </h2>
          <p className="text-sm text-foreground-500 mt-2">极致的观影体验，从午马开始</p>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
          {features.map((feat, idx) => (
            <div
              key={feat.title}
              className="text-center p-5 md:p-6 rounded-xl bg-background-50 animate-fade-in-up"
              style={{ animationDelay: `${idx * 0.1}s` }}
            >
              <span className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center mx-auto mb-3 rounded-xl bg-primary-100 text-primary-500">
                <i className={`${feat.icon} text-xl md:text-2xl`}></i>
              </span>
              <h3 className="text-sm md:text-base font-semibold text-foreground-950 mb-1.5">{feat.title}</h3>
              <p className="text-xs text-foreground-500 leading-relaxed">{feat.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}